import { Action, createReducer, on } from '@ngrx/store';
import { fromProductOnboardingFormsAction } from '../actions';
import { ErrorResponse, IGenericError } from '../../../../src/app/core/models/generic-models';
import { IStaticDataResponse } from '../models/static-data.model';

export const productOnboardingFormsFeatureKey = 'productOnboardingForms';

export interface ProductOnboardingFormsState {
  productOnboardingFormsResponse: IStaticDataResponse[];
  productOnboardingFormsFailure: IGenericError<ErrorResponse>;
  loaded: boolean;
}

export const initialState: ProductOnboardingFormsState = {
  productOnboardingFormsFailure: undefined,
  productOnboardingFormsResponse: undefined,
  loaded: undefined
};

export const reducer = createReducer(
  initialState,

  on(fromProductOnboardingFormsAction.loadProductOnboardingForms, (state, action) => ({
    ...state,
    loaded: true
  })),

  on(fromProductOnboardingFormsAction.loadProductOnboardingFormsSuccess, (state, action) => ({
    ...state,
    productOnboardingFormsResponse: action.response
  })),

  on(fromProductOnboardingFormsAction.loadProductOnboardingFormsFailure, (state, action) => ({
    ...state,
    productOnboardingFormsFailure: action.error
  }))
);

export const getProductOnboardingFormsResponse = (state: ProductOnboardingFormsState) => state.productOnboardingFormsResponse;
export const getProductOnboardingFormsFailure = (state: ProductOnboardingFormsState) => state.productOnboardingFormsFailure;
export const getProductOnboardingFormsIsLoaded = (state: ProductOnboardingFormsState) => state.loaded;
